import { render, staticRenderFns } from "./StaffPayoutsTable.vue?vue&type=template&id=6be5c2f2&"
import script from "./StaffPayoutsTable.vue?vue&type=script&lang=js&"
export * from "./StaffPayoutsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports